/* GENERATED FILE — DO NOT EDIT. Source: shared/assets/sticky-atc.js */
import { Component } from '@theme/component';

/**
 * Mobile sticky add-to-cart bar.
 *
 * Reveals itself once the main buy buttons have scrolled out of view, so it
 * never competes with the real add-to-cart button. Uses IntersectionObserver
 * against a sentinel resolved from `data-observe`, and falls back to always-on
 * if that target is missing.
 *
 * @extends {Component}
 */
class TiraStickyAtc extends Component {
  /** @type {IntersectionObserver | undefined} */
  #observer;

  connectedCallback() {
    super.connectedCallback();

    const selector = this.dataset.observe;
    const target = selector ? document.querySelector(selector) : null;

    if (!target) {
      // Nothing to watch — show it rather than silently never appearing.
      this.#setVisible(true);
      return;
    }

    this.#observer = new IntersectionObserver(([entry]) => this.#setVisible(entry ? !entry.isIntersecting : false), {
      rootMargin: '0px 0px -20% 0px',
    });
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
  }

  /** @param {boolean} visible */
  #setVisible(visible) {
    this.toggleAttribute('data-visible', visible);
    // Keep it out of the tab order and off the a11y tree while hidden.
    this.inert = !visible;
  }
}

if (!customElements.get('tira-sticky-atc')) {
  customElements.define('tira-sticky-atc', TiraStickyAtc);
}
